export default {
  ROOT: 1,      // ルート
  MEDIUM: 2,    // 中間
  TERMINAL: 3,  // 末端
}
